import React, { useEffect, useState } from "react";
import AddGroupLayout from "./AddGroupLayout";

const AddNewGroup = ({ selectedGroup, posts, getGroupPosts,groupLists,listTabs }) => {
  // console.log(groupLists)
  // console.log(selectedGroup)
  return (
    <>
      {selectedGroup?.length === "0" ? (
        <AddGroupLayout />
      ) : (
        <AddGroupLayout
        listTabs = {listTabs}
          groupLists={groupLists}
          selectedGroup={selectedGroup}
          posts={posts}
          getGroupPosts={getGroupPosts}
        />      )}
        
    </>
  );
};

export default AddNewGroup;
